import { Component, OnInit } from '@angular/core';
import { AuthService } from 'app/auth/auth.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { isStandalone } from '@angular/core';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
    styles: [],
    standalone: false
})
export class MainLayoutComponent implements OnInit {

  constructor(
    private activatedRoute: ActivatedRoute,
    private authService: AuthService
  ) { }

  ngOnInit() {

  }

}
